export const getExcelFileName = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return `Belimo Selected Products ${
        year
    }-${
        month < 10 ? `0${month}` : month
    }-${day} ${hours}-${minutes}.xlsx`;
};
